import { render, staticRenderFns } from "./DialogSendConversationToEmail.vue?vue&type=template&id=4457ccf3&scoped=true&"
import script from "./DialogSendConversationToEmail.vue?vue&type=script&lang=js&"
export * from "./DialogSendConversationToEmail.vue?vue&type=script&lang=js&"
import style0 from "./DialogSendConversationToEmail.vue?vue&type=style&index=0&id=4457ccf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457ccf3",
  null
  
)

export default component.exports